import "./error.scss";
import { type FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTitle } from "../../Utilities/TitleHook";
import Button from "../Button";

const Error404: FC = () => {
    useTitle("Not Found");

    const navigate = useNavigate();

    return (
        <div className="error error-404">
            <div className="title">
                404
            </div>
            <div className="subheading">
                Document could not be found
            </div>
            <div className="buttons">
                <Button
                    onClick={() => {
                        if(history.length !== 1) {
                            navigate(-1);
                        } else {
                            navigate("/");
                        }
                    }}
                    classes={[ "secondary-button" ]}
                >
                    Back
                </Button>
                <Button
                    onClick={() => navigate("/")}
                    classes={[ "primary-button" ]}
                >
                    Home
                </Button>
            </div>
        </div>
    );
};

export default Error404;
